export const detailUrl = ({ id }) =>
  `/management-contracts/detail/${id}/invoicing`;
